import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../../hooks/use-services.hook";
import {FieldsContainer2ColumnsBox, ProfileFieldComponent} from "../common/agency-profile-common.components";
import {translateGender} from "../../../../../services/dot-rez-api/data-contracts/enums/gender.enum";
import {useContainerMediaQueriesChecks} from "../../../../../hooks/use-container-media-queries-checks.hook";
import {formatPhoneNumber} from "../../../../../components/forms/contact/phone-number-helpers";


export const AgencyContactInformationViewComponent: React.FC = observer(() => {
    const services = useServices();
    const mediaQuery = useContainerMediaQueriesChecks();

    return(
            <FieldsContainer2ColumnsBox>
                <ProfileFieldComponent label={services.language.translate("Title")}
                                       value={services.user.profile.title}
                                       fullWidth={true}/>

                <ProfileFieldComponent label={services.language.translate("Name")}
                                       value={services.user.profile.getFullName()}
                                       fullWidth={true}/>

                <ProfileFieldComponent label={services.language.translate("Gender")}
                                       value={translateGender(services.user.profile.gender, services.language)}/>

                <ProfileFieldComponent label={services.language.translate("Date of Birth")}
                                       value={services.user.profile.formattedDateOfBirth}/>

                <ProfileFieldComponent label={services.language.translate("Country of residence")}
                                       value={services.user.profile.residentCountryName}/>

                <ProfileFieldComponent label={services.language.translate("Nationality")}
                                       value={services.user.profile.nationalityName}/>

                <ProfileFieldComponent label={services.language.translate("Email Address")}
                                       value={services.user.profile.emailAddress}
                                       fullWidth={true}/>

                <ProfileFieldComponent label={services.language.translate("Work phone number")}
                                       value={formatPhoneNumber(services.user.profile.workPhoneNumber)}
                                       isOnLastRow={!mediaQuery.smallScreen}/>

                <ProfileFieldComponent label={services.language.translate("Home phone number")}
                                       value={formatPhoneNumber(services.user.profile.phoneNumber)} isOnLastRow={true}/>

         </FieldsContainer2ColumnsBox>
    );
})